// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"c9d3c3e3","453":"7f50d41f","627":"3323bc58","867":"755bade3","923":"33c6c7be"}[chunkId] + ".chunk.js";
};